import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { FeatureFlagRow } from './app';

export interface FlagEditDialogData {
  flag: FeatureFlagRow;
}

@Component({
  selector: 'app-flag-edit-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './flag-edit-dialog.component.html',
  styleUrl: './flag-edit-dialog.component.scss'
})
export class FlagEditDialogComponent {
  protected readonly form;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dialogRef: MatDialogRef<FlagEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected readonly data: FlagEditDialogData
  ) {
    this.form = this.formBuilder.group({
      value: [this.data.flag.value, [Validators.required, Validators.maxLength(200)]]
    });
  }

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected save(): void {
    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close(this.form.controls.value.value?.trim() ?? '');
  }
}
